import { defineNuxtPlugin } from "#imports";
import { useSessionId } from "./composables/useSessionId.js";
import { useVisitorId } from "./composables/useVisitorId.js";
function refreshCookiesExpiration() {
  if (import.meta.server) {
    throw new Error(
      "[nuxt-module-identification] Cannot refresh cookies on server-side"
    );
  }
  useVisitorId({ forceRefresh: true });
  useSessionId({ forceRefresh: true });
}
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("app:mounted", refreshCookiesExpiration);
  nuxtApp.hook("page:start", refreshCookiesExpiration);
});
